const draftsKey = (userId) => `eventDrafts_${userId || 'anon'}`;

export const getDrafts = (userId) => {
    try {
        const saved = localStorage.getItem(draftsKey(userId));
        return saved ? JSON.parse(saved) : [];
    } catch (e) {
        return [];
    }
};

const persist = (userId, drafts) => {
    localStorage.setItem(draftsKey(userId), JSON.stringify(drafts));
};

// Adds a new draft, or updates one in place if draft.id already exists.
export const upsertDraft = (userId, draft) => {
    const drafts = getDrafts(userId);
    const index = drafts.findIndex(d => d.id === draft.id);
    if (index >= 0) {
        drafts[index] = draft;
    } else {
        drafts.push(draft);
    }
    persist(userId, drafts);
    return drafts;
};

export const deleteDraft = (userId, draftId) => {
    const drafts = getDrafts(userId).filter(d => d.id !== draftId);
    persist(userId, drafts);
    return drafts;
};

export const makeDraftId = () => `draft_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
